<template>
  <div class="form-row">
    <div class="form-group col-12">
      <p class="font-weight-bold">Select Effect</p>
      <div class="models-wrapper">
        <div v-for="(effect, key) in effects"
             :key="key"
             class="model-item"
             @click="changeSelectedModel(key, effect)"
             :class="{'active': activeEffect === effect.name }"
        >
          <template v-if="effect.hasOwnProperty('image')">
            <img :src="effect.image.imageURL" class="img-fluid"/>
          </template>
          <p>{{ effect.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { mapActions, mapState } from 'vuex'
import { uuid } from 'vue-uuid'

export default {
  components: {},
  data () {
    return {
      activeEffect: 'Select Effect'
    }
  },
  created () {
    this.listEffects()
    console.log(this.effects)
  },

  methods: {
    ...mapActions([
      'listEffects'
    ]),
    changeSelectedModel (index, model) {
      this.activeEffect = model.name
      this.characters.map((char) => ({ ...char, active: false }))
      // this.$store.dispatch('updateCharacters', this.characters.map((char) => ({ ...char, active: false,characterElements:[] })))
      let id = uuid.v1()
      let selectedOne = {
        objectId: id,
        type: "Effect",
        active: true,
        intId: 1,
        id: id,
        objectDbHash: index,
        name: model.name,
        effectType: model.effectType || '2D',
        prefabName: model.prefabName || model.name,
        iOSAssetBundle:  model.asset_bundle ? model.asset_bundle.iOS.fileURL : "",
        AndroidAssetBundle: model.asset_bundle ? model.asset_bundle.android.fileURL : "",
        webglAssetBundle: model.asset_bundle ? model.asset_bundle.WebGL.fileURL : "",
        position: [0,0,0],
        rotation: [0,0,0],
        scale: 0.5,
        startTime: 0,
        endTime: model.duration,
        presenceDuration: model.duration,
        loop: false,
      }
       this.$store.dispatch('updateCharacters', [
        ...this.characters.map((char) => ({ ...char, active: false})),
        selectedOne
      ])
      this.$emit('triggerSelectedModel', { index, model })
      this.$emit('closePopup')
    }
  },
  mounted () {},
  watch: {},
  computed: {
    ...mapState([
      'effects',
      'characters'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/timeline-components/effect.vue